import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-loading',
    templateUrl: './fi-loading.component.html',
    styleUrls: ['./fi-loading.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-loading' },
    standalone: false,
})
export class FiLoadingComponent {}
